import PropTypes from 'prop-types';
import { useReactToPrint } from 'react-to-print';
import React, { useEffect, useRef, useState } from 'react';
import { Dialog, Box, IconButton } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import CloseIcon from '@mui/icons-material/Close';
import { QUILL_PRINT_CONTENT_CSS } from 'components/QuillEditor/quillContentStyles';

export default function BasePrintModalA4({ open, onClose, children, title }) {
  const componentRef = useRef();
  const hasPrintedRef = useRef(false);
  const [isReadyToPrint, setIsReadyToPrint] = useState(false);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: title || 'PrintDocument',
    pageStyle: QUILL_PRINT_CONTENT_CSS,
    onAfterPrint: onClose
  });

  useEffect(() => {
    if (open) {
      const timeout = setTimeout(() => {
        setIsReadyToPrint(true);
      }, 300);
      return () => clearTimeout(timeout);
    }
  }, [open]);

  useEffect(() => {
    if (isReadyToPrint && !hasPrintedRef.current && open) {
      hasPrintedRef.current = true;
      handlePrint();
    }
  }, [isReadyToPrint, open, handlePrint]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
        <IconButton onClick={handlePrint}><PrintIcon /></IconButton>
        <IconButton onClick={onClose}><CloseIcon /></IconButton>
      </Box>
      <Box
        ref={componentRef}
        sx={{
          p: 3,
          '@media print': {
            padding: '12px',
            margin: 0,
            width: '100%',
            fontSize: '12px',
          }
        }}
      >
        {React.cloneElement(children, { handlePrint: handlePrint, onClose: onClose })}

      </Box>
    </Dialog>
  );
}

BasePrintModalA4.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
};
